import * as React from "react";
import { useViewportSimulatorSafe } from "@/contexts/ViewportSimulatorContext";

const MOBILE_BREAKPOINT = 1024;

/**
 * Hook that returns whether the current viewport is mobile (< 768px).
 * Uses synchronous initialization to avoid flash of loading state.
 * Simplified for Mobile + PC only (no tablet breakpoint).
 * 
 * @returns boolean - true for mobile, false for desktop
 */
export function useIsMobile(): boolean {
  const { simulatedViewport } = useViewportSimulatorSafe();
  
  // Initialize synchronously to avoid loading flash
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < MOBILE_BREAKPOINT;
  });

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  // Se está simulando viewport mobile
  if (simulatedViewport === 'mobile') return true;

  return isMobile;
}
